import { Link } from 'react-router';

import Button from '@cartwhl/ui/input/Button';

import AuthPageLayout from './AuthPageLayout';

enum ERRORS {
  A = 'Malformed request received. Expected queryStringParameters but received none',
  B = 'Unable to reset user to a clean slate. Future sign-ups may have issues, reach out for support.',
  C = 'Unable to initiate password reset. Try again later!',
  D = 'No session found, cannot log out',
  E = 'Email address was not found. Please try again.',
  F = 'Unable to verify email. Try again later!',
  G = 'No invite was provided. Check your link and try again.',
  H = 'Invite could not be found. Check your link and try again.',
  I = 'Invite has already been claimed. Check your link and try again.',
  J = 'Email used was {email}, but the invite used is only valid for {maskedEmail}',
  K = 'Unable to get Stytch secret from SecretsManager',
  L = 'Unsupported token type',
}

export default function LoginErrorPage() {
  const params = new URLSearchParams(window.location.search);
  const errorCode = params.get('errorCode');
  const errorMessage =
    typeof errorCode === 'string' && errorCode in ERRORS
      ? ERRORS[errorCode as keyof typeof ERRORS]
      : 'Shoot, There was an error during login.';

  return (
    <AuthPageLayout title={errorMessage}>
      <Link
        to={`/login${
          params.has('redirectTo')
            ? `?redirectTo=${params.get('redirectTo')}`
            : ''
        }`}
        className="mb-10 w-full"
      >
        <Button variant="secondary" className="w-full">
          Try again
        </Button>
      </Link>
    </AuthPageLayout>
  );
}
